export default (state = [], action) => {
  var segmentsNew;
  var currentSegmentIsEditable;
  switch (action.type){
    case 'GET_XLIF':
//		console.log('GET_XLIF reducer:'+action.xliff );
    	return {
			xliff: action.xliff,
			TUs: [],
			tmx: [],
			current:{
				iTu: 0,
				iSeg: 0
			}
		};
	case 'UPDATE_XLIF':
		return {...state, xliff: action.xliff};
		
	case 'GET_SEGMENTS':		
    	return {...state, TUs: action.TUs};

	case 'NEXT_SEG':
		//console.log(state);
		let inicial= {iTu:state.current.iTu, iSeg:state.current.iSeg};
		let next= {iTu:state.current.iTu, iSeg:state.current.iSeg};
		let volta = false;
		currentSegmentIsEditable = false;
		while(!currentSegmentIsEditable && !volta){
			console.log(next.iTu+","+next.iSeg);
			if(state.TUs[next.iTu].segments.length>(next.iSeg+1)){
				next.iSeg++;
			}else if(state.TUs.length>(next.iTu+1)){
				next.iTu++;
				next.iSeg=0;
			}else{
				next.iTu=0;
				next.iSeg=0;
			}
			currentSegmentIsEditable = (typeof state.TUs[next.iTu].segments[next.iSeg]!=="undefined")
									&&(typeof state.TUs[next.iTu].segments[next.iSeg].trg.state!=="undefined")
									&&(state.TUs[next.iTu].segments[next.iSeg].trg.state!=="blocked");
			if(inicial.iTu===next.iTu && inicial.iSeg===next.iSeg){
				volta = true;
			}
		}
    	return {...state, current: next};

	case 'PREVIOUS_SEG':
		let inicial2= {iTu:state.current.iTu, iSeg:state.current.iSeg};
		let prev = {iTu:state.current.iTu, iSeg:state.current.iSeg};
		let volta2 = false;
		currentSegmentIsEditable = false;
		while(!currentSegmentIsEditable && !volta2){
			console.log(prev.iTu+","+prev.iSeg);
			if(prev.iSeg>0){
				prev.iSeg--;
			}else if(prev.iTu>0){
				prev.iTu--;
				prev.iSeg=state.TUs[prev.iTu].segments.length-1;
			}else{
				prev.iTu=state.TUs.length-1;
				prev.iSeg=state.TUs[prev.iTu].segments.length-1;
			}
			currentSegmentIsEditable = (typeof state.TUs[prev.iTu].segments[prev.iSeg]!=="undefined")
									&&(typeof state.TUs[prev.iTu].segments[prev.iSeg].trg.state!=="undefined")
									&&(state.TUs[prev.iTu].segments[prev.iSeg].trg.state!=="blocked");
			if(inicial2.iTu===prev.iTu && inicial2.iSeg===prev.iSeg){
				volta2 = true;
			}
		}
		//let prev = (state.current>0) ? state.current-1:0;
		//console.log('PREVIOUS_SEG current:'+state.current+', length:'+state.segments[0].length+', prev:'+prev );
    	return {...state, current: prev};

	case 'GOTO_SEG':
		let newCurrent = {iTu:action.iTu, iSeg:action.iSeg};
		return {...state, current: newCurrent};

	case 'UPDATE_CURR_SEG':
//		console.log('UPDATE_CURR_SEG['+state.current+']: '+action.text);
    	//return {...state, segments: state.segments.map((content, i) => i === state.current ? {...content, text: action.text}:content)};
		segmentsNew=[...state.TUs];
		segmentsNew[state.current.iTu].segments[state.current.iSeg] = action.segmentMod;
		return {...state, segments: segmentsNew};
		
	case 'UPDATE_SEG':
		segmentsNew=[...state.TUs];
		segmentsNew[action.iTu].segments[action.iSeg] = action.segmentMod;
		return {...state, segments: segmentsNew};
		
	case 'UPDATE_CURR_SPELL_ERROR':	
		let segmentsNew=[...state.TUs];
		segmentsNew[state.current.iTu].segments[state.current.iSeg] = action.segmentMod;
		return {...state, segments: segmentsNew};
	
	case 'SET_TMX':
		return {...state, tmx: action.tmx};
		
    default:
		return state;
  }
};